import { InvoicePayload } from '@features/invoices/types/invoicePayload'
import { RECURRING_INVOICE_EMAIL_TEMPLATE_RECIPIENTS_SEPARATOR } from '@features/recurringInvoices/constants/recurringInvoiceEmailTemplateRecipientsSeparator'
import { RecurringInvoiceDuration } from '@features/recurringInvoices/enums/recurringInvoiceDuration'
import { RecurringInvoiceDraftPayload } from '@features/recurringInvoices/types/recurringInvoiceDraftPayload'
import { RecurringInvoiceSchedule } from '@features/recurringInvoices/types/recurringInvoiceSchedule'

import { convertDateToUTC } from '../../../../../../utils'
import { RecurringInvoiceForm } from '../../types/recurringInvoiceForm/recurringInvoiceForm'

interface GetRecurringInvoicePayloadOptions {
  invoiceDraftPayload: InvoicePayload
  recurringInvoiceFormData: RecurringInvoiceForm
  id?: number
}

export const getRecurringInvoicePayload = ({
  invoiceDraftPayload,
  recurringInvoiceFormData,
}: GetRecurringInvoicePayloadOptions): RecurringInvoiceDraftPayload => {
  const { delivery, deliveryNotification, duration, firstInvoiceDate, frequency, id, occurrences, message } =
    recurringInvoiceFormData

  const schedule: RecurringInvoiceSchedule = {
    action: delivery,
    confirmation: deliveryNotification,
    frequency,
    repeat: duration === RecurringInvoiceDuration.Repeat ? occurrences : null,
    startDate: firstInvoiceDate
      ? convertDateToUTC(firstInvoiceDate).toISOString()
      : convertDateToUTC(new Date()).toISOString(),
    message: {
      acceptStripePayment: message.acceptStripePayment,
      body: message.body,
      to: message.to.join(RECURRING_INVOICE_EMAIL_TEMPLATE_RECIPIENTS_SEPARATOR),
    },
  }

  return {
    schedule,
    draft: invoiceDraftPayload,
    ...(id ? { id } : {}),
  }
}
